import gql from 'graphql-tag';

export default gql`
  query searchSupplier($input: SearchSupplierInput) {
    searchSupplier(input: $input) {
      data {
        id
        name
      }
      pageInfo {
        size
        page
        totalItems
        totalPages
      }
    }
  }
`;
